import type { ActivityPlugin } from '../../core/types/activity.types';
import { GAME_MODE_CATALOG } from '../../core/types/gameMode.types';
import { countingCollectionLogic } from './counting_collection.logic';
import { CountingCollectionActivityView } from './CountingCollectionViews';

export const countingCollectionPlugin: ActivityPlugin<'counting_collection'> = {
  ...countingCollectionLogic,
  displayName: GAME_MODE_CATALOG.counting_collection.displayName,
  icon: GAME_MODE_CATALOG.counting_collection.icon,
  HostView: CountingCollectionActivityView,
  StudentView: CountingCollectionActivityView,
  ProjectorView: CountingCollectionActivityView,
};

export { demoCountingCollectionPayload } from './counting_collection.logic';
